import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import Header from "../components/Header"

const Terms: React.FC = () => {
	const navigate = useNavigate()

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			// behavior: "smooth",
		})
	}, [])

	return (
		<>
			<Header />
			<div className="container mx-auto max-w-[800px] py-8 px-4 text-justify">
				<h2 className="text-yellow leading-tight">Teilnahme&shy;bedingungen</h2>
				<p className="mb-8 mt-8">
					Mit der Teilnahme an der Aktion akzeptiert der Teilnehmer die folgenden Teilnahmebedingungen:
				</p>
				<h3 className="text-[25px] sm:text-[35px] text-yellow py-4">1. Veranstalter</h3>
				<p className="mb-8 ">
					Die <strong>Wilkinson Sword GmbH, Schützenstraße 110, D-42659 Solingen</strong> (im Folgenden
					„Veranstalter" oder „Wilkinson Sword" genannt) veranstaltet in der Zeit vom{" "}
					<strong>06.05.2026 bis 10.06.2026</strong> mit den Marken Wilkinson Sword Intuition und Hawaiian
					Tropic eine befristete Gewinnspielpromotion mit Verlosung.
				</p>
				<p className="mb-8 ">
					Die Abwicklung der Aktion erfolgt durch die{" "}
					<strong>Magellan GmbH, Theo-Champion-Str. 2, D-40549 Düsseldorf</strong> und die{" "}
					<strong>direct services Gütersloh GmbH, Reinhard-Mohn-Str. 300, 33333 Gütersloh</strong>.
				</p>
				<h3 className="text-[25px] sm:text-[35px] text-yellow py-4">2. Teilnahmeberechtigung</h3>
				<p className="mb-8 ">
					Teilnehmen dürfen <strong>natürliche Personen ab 18 Jahren mit Wohnsitz in Deutschland</strong>.
					Mitarbeiter des Veranstalters sind nicht teilnahmeberechtigt.
				</p>
				<p className="mb-8 ">
					Außerdem behält sich der Veranstalter das Recht vor, Personen von der Teilnahme auszuschließen, bei
					denen der Verdacht besteht, dass sie sich bei der Teilnahme unerlaubter Hilfsmittel bedienen oder in
					sonstiger Weise versuchen, sich oder Dritten durch Manipulation Vorteile zu verschaffen. Der
					Ausschluss kann in diesem Fall auch nach der Teilnahme erfolgen. Der Veranstalter hat das Recht die
					Gewinnausschüttung zu verweigern bzw. den Gewinn zurückzufordern.
				</p>
				<h3 className="text-[25px] sm:text-[35px]  text-yellow py-4">
					3. Teilnahmevoraussetzung / Aktionsprodukte
				</h3>
				<p className="mb-8 ">
					Voraussetzung für die Teilnahme an der Verlosung ist der{" "}
					<strong>Kauf eines Aktionsproduktes</strong> in der Filiale des teilnehmenden Händlers{" "}
					<strong>dm</strong>, im Zeitraum <strong>06.05.2026 bis 10.06.2026 um 23:59 Uhr</strong> deutscher
					Zeit.
				</p>
				<p className="mb-8 ">
					Aktionsprodukte sind die folgenden Produkte der Marke „Hawaiian Tropic" und „Wilkinson Sword
					Intuition", die vom teilnehmenden Händler dm angeboten werden:
					<ul className="pl-8">
						<li className="list-disc">4027800176403 Wilkinson Sword Intuition Complete Care Starterpack</li>
						<li className="list-disc">4027800183807 Wilkinson Sword Intuition Eyebrow Shaper XL Pack</li>
						<li className="list-disc">
							4027800179909 Wilkinson Sword Intuition Quattro Sensitive Starterpack
						</li>
						<li className="list-disc">
							4027800190409 Wilkinson Sword Intuition 2in1 Soap&amp;Shave Nourishing Starterpack
						</li>
						<li className="list-disc">
							4027800085002 Wilkinson Sword Intuition und Hawaiian Tropic Summer Essential Giftset
						</li>
					</ul>
				</p>
				<p className="mb-8 ">
					Die Teilnahmeberechtigung ergibt sich aus dem jeweiligen Rechnungsbeleg, auf dem das Aktionsprodukt
					aufgeführt ist. Jeder Rechnungsbeleg darf <strong>nur einmal</strong> zur Teilnahme am Gewinnspiel
					verwendet werden und stellt somit nur <strong>eine</strong> Gewinnchance dar, auch wenn mehrere
					Produkte gekauft wurden.
				</p>
				<h3 className="text-[25px] sm:text-[35px]  text-yellow py-4">4. Teilnahme & Gewinnbenachrichtigung</h3>
				<p className="mb-8 ">
					Die Teilnahme an der Verlosung ist ausschließlich online über die Aktionswebsite{" "}
					<a
						href="https://wilkinsonsword.de/pages/frauen/gewinnspiel-Ibiza-2026"
						target="_blank"
						className="underline"
					>
						https://wilkinsonsword.de/pages/frauen/gewinnspiel-Ibiza-2026
					</a>{" "}
					möglich. Teilnahmeschluss ist der <strong>10.06.2026 um 23:59 Uhr</strong> deutscher Zeit.
				</p>
				<p className="mb-8 ">
					Um teilzunehmen, muss ein Foto des vollständigen Rechnungsbelegs hochgeladen sowie das
					Teilnahmeformular vollständig ausgefüllt und abgeschickt werden.
				</p>
				<p className="mb-8 ">
					Die Teilnehmer können ihre Teilnahme jederzeit per E-Mail an{" "}
					<a href="mailto:Intuition@gewinnspiel-2026.de" className="underline">
						Intuition@gewinnspiel-2026.de
					</a>{" "}
					widerrufen. Die Entscheidung ist endgültig und es wird keine Korrespondenz geführt. Der Rechtsweg
					sowie jegliche weitere Korrespondenz sind ausgeschlossen.
				</p>
				<p className="mb-8 ">
					Die Ermittlung der Gewinner erfolgt innerhalb von zwei Wochen nach Aktionsende per Zufallsziehung
					aus allen gültigen Teilnahmen. Die Gewinner werden per E-Mail über ihren Gewinn und
					Zustellungstermin informiert und müssen formlos (per E-Mail) die Gewinnannahme bestätigen. Nimmt der
					Teilnehmer den Gewinn nicht an oder meldet sich nach zweimaliger Aufforderung innerhalb eines Monats
					nicht zurück, so verfällt der Gewinnanspruch und ein neuer Gewinner wird ermittelt.
				</p>
				<p className="mb-8 ">
					Der Gewinnanspruch (auf eine Reise nach Ibiza für 2 Personen im Wert von bis zu 5.000 €) entsteht
					erst nachdem Wilkinson Sword den originalen Rechnungsbeleg erhält und diesen geprüft hat. Teilnehmer
					sind verpflichtet den originalen Rechnungsbeleg aufzubewahren und ihn Wilkinson Sword zur
					abschließenden Prüfung zur Verfügung zu stellen. Zur Übermittlung des originalen Rechnungsbelegs
					setzt sich Wilkinson Sword oder eine von Wilkinson Sword beauftragte Agentur per E-Mail mit dem
					Gewinner in Verbindung. Geht der originale Rechnungsbeleg verloren, wird keine Haftung übernommen,
					daher empfehlen wir den Versand per versichertem Einschreiben. Nach Eingang und Prüfung des
					Rechnungsbelegs werden alle für den Empfang des Gewinns notwendigen Details von einer Wilkinson
					Sword Agentur mit dem Gewinner besprochen.
				</p>
				<p className="mb-8 ">
					Der Gewinner trägt die Kosten für die Einsendung des originalen Rechnungsbelegs.
				</p>
				<p className="mb-8 ">
					Wir empfehlen Ihnen, den originalen Kaufbeleg aufzubewahren, bis Sie Ihren Gewinn erhalten haben.
					Sobald Sie Ihren Gewinn erhalten haben, wird der Kaufbeleg nicht mehr benötigt.
				</p>
				<h3 className="text-[25px] sm:text-[35px]  text-yellow py-4">5. Gewinne</h3>
				<p className="mb-8 ">
					Im Rahmen dieser Gewinnspielaktion wird eine Reise nach Ibiza für 2 Personen verlost; der
					Einlöse-Zeitraum beträgt 2 Jahre.
				</p>
				<p className="mb-8 ">
					Der Gewinner stellt mit unserem Reisebüro des Vertrauens seine individuelle Traumreise im Wert von
					bis zu 5.000 € zusammen. Alle Details der Reise werden direkt zwischen Reisebüro und dem Gewinner
					abgestimmt.
				</p>
				<p className="mb-8 ">
					Eine Barauszahlung der Gewinne ist nicht möglich. Gewinnansprüche können nicht auf andere Personen
					übertragen oder abgetreten werden. Der Rechtsweg ist ausgeschlossen.
				</p>
				<h3 className="text-[25px] sm:text-[35px]  text-yellow py-4">6. Datenschutz</h3>
				<p className="mb-8 ">
					Die Teilnehmerdaten (Vorname, Nachname, Adresse, E-Mail-Adresse und Geburtsdatum) werden vom
					Veranstalter und seinen Dienstleistern nur zum Zwecke der Durchführung und Abwicklung der Aktion
					gespeichert und verarbeitet (Art. 6 Abs. 1 lit. b DSGVO). Eine Weitergabe der Daten an Dritte
					erfolgt nicht. Die Adressdaten werden nur von Gewinnern zum Zweck der Preisvergabe erhoben.
				</p>
				<p className="mb-8 ">
					Der Veranstalter kann Gewinnerdaten an seine Dienstleister Magellan GmbH und direct services
					Gütersloh GmbH zur Verwaltung der Aktion sowie an das beauftragte Reisebüro zum Zweck der Buchung
					und Koordination der Gewinnreise weitergeben. Diese Dienstleister verarbeiten Daten ausschließlich
					im Auftrag und gemäß den Anweisungen des Veranstalters gemäß Art. 28 DSGVO.
				</p>
				<p className="mb-8 ">
					Zusätzlich zu den oben genannten Daten verarbeitet der Veranstalter folgende personenbezogene Daten
					des Gewinners zum Zweck der Preisabwicklung: Name und Kontaktdaten, ggf. Personalausweis und/oder
					Reisepass-Informationen (Name, Geburtsdatum, Reisepassnummer, Staatsangehörigkeit, Ablaufdatum),
					Bankverbindung für eventuelle Erstattungen [abhängig von der Durchführung der Reise].
				</p>
				<p className="mb-8 ">
					Die Verarbeitung von Personalausweisdaten ist für Flug- und Hotelbuchung erforderlich; Bankdaten
					werden nur verarbeitet, wenn im Zusammenhang mit der Reise Rückerstattungen erforderlich werden.
				</p>
				<p className="mb-8 ">
					Der Veranstalter verarbeitet personenbezogene Daten auf der Rechtsgrundlage von Art. 6 Abs. 1 lit. b
					DSGVO (Erfüllung eines Vertrags) zum Zweck der Durchführung des Gewinnspiels und der Übergabe des
					Preises an den Gewinner. Die Teilnehmer haben das Recht, Auskunft über die Verarbeitung ihrer
					personenbezogenen Daten zu erhalten; vom Veranstalter die Berichtigung, Löschung oder Einschränkung
					der Verarbeitung ihrer personenbezogenen Daten zu verlangen und die bereitgestellten
					personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten
					und an einen anderen Verantwortlichen zu übermitteln. Zur Ausübung ihrer Rechte können sich die
					Teilnehmer per E-Mail an{" "}
					<a href="mailto:privacy@edgewell.com" className="underline">
						privacy@edgewell.com
					</a>{" "}
					oder{" "}
					<a href="mailto:Intuition@gewinnspiel-2026.de" className="underline">
						Intuition@gewinnspiel-2026.de
					</a>{" "}
					an den Verantwortlichen wenden.
				</p>
				<p className="mb-8 ">
					Die Teilnehmer können jederzeit Widerspruch gegen die Verarbeitung einlegen. Soweit der Veranstalter
					die personenbezogenen Daten auf Grundlage einer Einwilligung verarbeitet, können die Teilnehmer
					diese jederzeit durch Kontaktaufnahme mit dem Veranstalter unter{" "}
					<a href="mailto:privacy@edgewell.com" className="underline">
						privacy@edgewell.com
					</a>{" "}
					oder{" "}
					<a href="mailto:intuition@gewinnspiel-2026.de" className="underline">
						intuition@gewinnspiel-2026.de
					</a>{" "}
					widerrufen. Die Teilnehmer können auch eine Beschwerde bei der zuständigen Datenschutzbehörde
					einreichen.
				</p>
				<p className="mb-8 ">
					Personenbezogene Daten von Teilnehmern, die nicht gewinnen, werden innerhalb von drei (3) Monaten
					nach Abschluss der Verlosung gelöscht. Personenbezogene Daten des Gewinners werden innerhalb von
					drei (3) Monaten nach vollständiger Durchführung der Reise gelöscht, es sei denn, gesetzliche
					Aufbewahrungsfristen erfordern eine längere Speicherung. In solchen Fällen werden die Daten nach
					Ablauf der geltenden Aufbewahrungsfrist gelöscht.
				</p>
				<h3 className="text-[25px] sm:text-[35px]  text-yellow py-4">7. Haftung</h3>
				<p className="mb-8 ">
					Der Veranstalter haftet nach den gesetzlichen Bestimmungen für eigenes Verschulden und grobe
					Fahrlässigkeit, sowie das seiner gesetzlichen Vertreter, leitenden Angestellten oder sonstigen
					Erfüllungsgehilfen. Das Gleiche gilt für die Übernahme von Garantien oder sonstiger
					verschuldensunabhängiger Haftung sowie für Ansprüche nach dem Produkthaftungsgesetz oder bei
					schuldhafter Verletzung von Leben, Körper oder Gesundheit.
				</p>
				<p className="mb-8 ">
					Der Veranstalter haftet dem Grunde nach für die eigene, die seiner Vertreter, leitenden Angestellten
					und einfachen Erfüllungsgehilfen einfache fahrlässige Verletzung wesentlicher Vertragspflichten,
					d.h. solcher Pflichten, auf deren Erfüllung der Teilnehmer regelmäßig vertrauen darf, um die Aktion
					ordnungsgemäß durchführen zu können; in diesem Fall ist die Haftung der Höhe nach auf den
					typischerweise entstehenden, vorhersehbaren Schaden begrenzt.
				</p>
				<p className="mb-8 ">Jede weitere Haftung des Veranstalters ist ausgeschlossen.</p>
				<h3 className="text-[25px] sm:text-[35px]  text-yellow py-4">8. Beendigung der Aktion</h3>
				<p className="mb-8 ">
					Die Aktion kann jederzeit ohne Vorankündigung und ohne Angabe von Gründen geändert, verlängert, für
					einen vorübergehenden Zeitraum ausgesetzt oder vorzeitig beendet werden. Hieraus entstehen keine
					Ansprüche gegen den Veranstalter.
				</p>
				<h3 className="text-[25px] sm:text-[35px]  text-yellow py-4">9. Sonstiges</h3>
				<p className="mb-8 ">
					Sollten einzelne Bestimmungen ganz oder teilweise unwirksam sein oder werden, bleibt die Gültigkeit
					der übrigen Teilnahmebedingungen hiervon unberührt.
				</p>
				<p className="mb-8 ">Ausschließlich anwendbares Recht ist das Recht der Bundesrepublik Deutschland.</p>
				<p className="mb-8 ">
					Gerichtsstand für alle Streitigkeiten, die sich aus oder im Zusammenhang mit dieser Aktion ergeben,
					ist Solingen, Deutschland, soweit gesetzlich zulässig. Die zuständige alternative
					Streitbeilegungsstelle für Verbraucherstreitigkeiten, die aus dieser Aktion resultieren, ist:
					Universalschlichtungsstelle des Bundes (Zentrum für Schlichtung e.V.), Straßburger Straße 8, 77694
					Kehl am Rhein, Deutschland, Website:{" "}
					<a href="https://www.verbraucher-schlichter.de" target="_blank" className="underline">
						www.verbraucher-schlichter.de
					</a>
					. Der Veranstalter ist weder verpflichtet noch bereit, an Streitbeilegungsverfahren vor einer
					Verbraucherschlichtungsstelle im Sinne des VSBG teilzunehmen.
				</p>
				<p className="mb-8 ">
					Sämtliche Fragen oder Anmerkungen zur Aktion sind per E-Mail an{" "}
					<a href="mailto:privacy@edgewell.com" className="underline">
						privacy@edgewell.com
					</a>{" "}
					zu richten.
				</p>
			</div>
			<div className="py-10 pt-5  text-center">
				<button onClick={() => navigate(-1)} className="btn btn-yellow">
					Zurück
				</button>
			</div>
		</>
	)
}
export default Terms
